import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";
import { NotFoundError } from "@shared/utils/not-found-error";

import { mapDtoToArticles, type NewsListType } from "@/_pages/news/model";
import { mapDtoToNewsPage } from "@/_pages/news/model/mappers";
import type { NewsPageType } from "@/_pages/news/model/types";

import { isNotFound } from "./is-not-found";
import { searchParams } from "./params";

type DataType = {
  page: NewsPageType;
  list: NewsListType;
};

/**
 * Страница блога и статьи устроены так же, как у новостей, поэтому схемы и
 * мапперы берём оттуда. page стоит первым: SEO страницы ищется обходом cms,
 * и первым должен найтись seo раздела, а не какой-нибудь статьи
 */
export const getBlogPage = async () => {
  const blogPageData = strapiClient.single("blog-page");
  const posts = strapiClient.collection("blog-posts");

  try {
    const [blogPage, list] = await Promise.all([
      blogPageData.find({
        ...searchParams.page,
      }),
      posts.find({
        ...searchParams.posts,
      }),
    ]);

    return rebuild({
      page: mapDtoToNewsPage(blogPage),
      list: mapDtoToArticles(list),
    }) as DataType;
  } catch (error) {
    // Пока «Страница блога» не создана и не опубликована, Strapi отвечает 404:
    // отдаём посетителю честную 404, а не пятисотку
    if (isNotFound(error)) {
      throw new NotFoundError("Blog page is not published yet");
    }

    throw error;
  }
};
